<script lang="ts">
import { inject } from 'vue'
import html2canvas from "html2canvas";
import ControlButton from 'ol-ext/control/Button'

// https://openlayers.org/en/latest/examples/print-to-scale.html
// https://viglino.github.io/ol-ext/examples/canvas/map.control.printdialog.html
// https://vue3openlayers.netlify.app/componentsguide/mapcontrols/printdialog/#openwindow
// https://viglino.github.io/ol-ext/examples/canvas/map.canvas.control.html

// NE FONCTIONNE PAS POUR LINSTANT
export default {
    name: 'DkOlPrint',
    components: {},
    data() {
        return {
            map: inject('map'),
            printControl: null,
        }
    },
    mounted() {
        this.printControl = new ControlButton ({
            html: '<span class="mdi mdi-download"></span>',
            className: "print-button",
            title: "Télécharger la carte",
            handleClick: () => {
                this.print()
            }
        });
        this.map.addControl(this.printControl);
    },
    unmounted(): void {
        this.map.removeControl(this.printControl)
        delete this.printControl
    },
    methods: {
        print() {
            const legendBox = document.querySelector('.ol-legend.ol-control:not(.ol-collapsed)')
            const searchPlacemark = document.querySelector('.ol-popup.placemark')

            const buttons = document.querySelectorAll('.ol-button.ol-control')
            console.log(legendBox, buttons)

            buttons.forEach( btn => btn.style.display = 'none')

            if (legendBox) {
                legendBox.style.display = 'none'
            }
            if (searchPlacemark) {
                searchPlacemark.style.display = 'none'
            }
            html2canvas(document.getElementById('fullscreen datakode-map')).then((canvas) => {
                const today = new Date()
                const image = canvas.toDataURL('image/png');
                const link = document.createElement('a');
                link.download = `${today.toISOString()}.png`;
                link.href = image;
                link.click();
                if (legendBox) {
                    legendBox.style.display = 'inherit'
                }
                if (searchPlacemark) {
                    searchPlacemark.style.display = 'inherit'
                }
                buttons.forEach( btn => btn.style.display = 'inherit')
            });



        }
    },
    render() {
        return null
    },
}
</script>
<style>
.print-button.ol-control {
    top:4em;
    left:0.5em;
}
</style>
